import React, { useRef, useState } from "react";
import { View, Text, TouchableOpacity, Image, StyleSheet } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import { formatTimestamp } from "../formatTimestamp";
import withErrorBoundary from "../../utility/auth/withErrorBoundary";
import { Dimensions } from "react-native";
import MessageOnClickModal from "./MessageOnClickModal";

interface MessageItemProps {
  item: any;
  isSender: boolean;
  userData: any;
  currentChat: any;
  handleDeletePress?: any;
  selectionMode: boolean;
  selectedMessages?: any[];
  setSelectedMessages?: any;
}

const MessageItem: React.FC<MessageItemProps> = ({
  item,
  isSender,
  userData,
  currentChat,
  handleDeletePress,
  selectionMode,
  selectedMessages,
  setSelectedMessages,
}) => {
  const [showPopup, setShowPopup] = useState(false);

  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });

  const messageRef = useRef(null);

  const handleLongPress = () => {
    if (!selectionMode) {
      setSelectedMessages([...selectedMessages, item.messageId]);
      messageRef.current.measureInWindow((x, y, width, height) => {
        const screenHeight = Dimensions.get("window").height;
        const popupTopPosition = y + height + 5;
        const popupLeftPosition = isSender ? x + width - 120 : x;
        setPopupPosition({
          top: Math.min(popupTopPosition, screenHeight - 150),
          left: popupLeftPosition,
        });
        setShowPopup(true);
      });
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const otherMembersRead = currentChat.members
    .filter((member: string) => member !== userData.username)
    .every((member: string) => item.readStatus?.[member]);

  return (
    <>
      {isSender ? (
        <TouchableOpacity
          ref={messageRef}
          style={{ marginVertical: 10 }}
          onLongPress={handleLongPress}
          activeOpacity={1}
        >
          <View style={styles.senderMessageContainer}>
            <Text
              style={[
                AppFontStyle.MEDIUM_ANYBODY_14,
                {
                  paddingBottom: 5,
                  maxWidth: 400,
                },
              ]}
            >
              {item.messageContent}
            </Text>
            <View style={{ alignSelf: "flex-end" }}>
              <View style={styles.senderStatusContainer}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    {
                      color: "rgba(255, 255, 255, 0.50)",
                      textTransform: "capitalize",
                      paddingBottom: 5,
                      marginLeft: 25,
                    },
                  ]}
                >
                  {formatTimestamp(item.timestamp)}
                </Text>
                <Image
                  source={
                    otherMembersRead ? AppImages.icnGreenTick : AppImages.icTick
                  }
                  style={{ height: 16, width: 16, resizeMode: "contain" }}
                />
              </View>
            </View>
          </View>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          ref={messageRef}
          style={styles.receiverMessageContainer}
          onLongPress={handleLongPress}
          activeOpacity={1}
        >
          <View style={styles.senderMainWrapper}>
            <View style={styles.senderChatWrapper}>
              {currentChat.type === "group" && (
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_12,
                    { color: AppColors.purpleColor_9D2CF5, paddingBottom: 10 },
                  ]}
                >
                  {item.userId}
                </Text>
              )}
              <View style={{}}>
                <Text
                  style={[
                    AppFontStyle.MEDIUM_ANYBODY_14,
                    {
                      color: "#1D072D",
                      paddingBottom: 5,
                      maxWidth: 400,
                    },
                  ]}
                >
                  {item.messageContent}
                </Text>
                <View style={{ alignSelf: "flex-end" }}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      {
                        color: "rgba(0, 0, 0, 0.50)",
                        textTransform: "capitalize",
                        paddingBottom: 5,
                        marginLeft: 25,
                      },
                    ]}
                  >
                    {formatTimestamp(item.timestamp)}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </TouchableOpacity>
      )}
      {showPopup && (
        <MessageOnClickModal
          showPopup={showPopup}
          handleClosePopup={handleClosePopup}
          popupPosition={popupPosition}
          messageContent={item.messageContent}
          onDeletePress={handleDeletePress}
        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  senderMessageContainer: {
    marginStart: "35%",
    alignSelf: "flex-end",
    paddingHorizontal: 12,
    paddingTop: 10,
    borderRadius: 2,
    backgroundColor: "rgba(220, 38, 38, 0.50)",
    width: "100%",
    flex: 1,
  },
  senderStatusContainer: {
    flex: 1,
    flexDirection: "row",
    // marginTop: 10,
    alignSelf: "flex-end",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },
  receiverMessageContainer: {
    flex: 1,
  },
  senderMainWrapper: {
    flex: 1,
    width: "100%",
    flexDirection: "row",
    marginTop: 8,
    columnGap: 8,
    alignSelf: "flex-start",
  },
  profileIcon: {
    backgroundColor: AppColors.purpleColor_9D2CF5,
    width: 32,
    height: 32,
    borderRadius: 100,
    alignSelf: "flex-end",
  },
  senderChatWrapper: {
    maxWidth: "65%",
    marginEnd: "35%",
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
    borderRadius: 2,
    backgroundColor: "#FFFFFF",
  },

  bottomBar: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    height: 50,
    backgroundColor: AppColors.purpleColor_9D2CF5,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 20,
  },
  cancelButton: {
    padding: 8,
    backgroundColor: AppColors.grayColor_282828,
    borderRadius: 5,
  },
});

export default withErrorBoundary(MessageItem);
